<template>
  <div>
    <el-dialog-zdy
      append-to-body
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div>
        <el-table
          :data="dataList"
          :height="bodyHeight - 200"
          style="width: 100%">
          <el-table-column   label="名称" align="center">
            <template slot-scope="scop">
              随堂检测第 {{scop.$index+1}} 次
            </template>
          </el-table-column>

          <el-table-column   label="是否合格" align="center">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.isQualified===1">合格</el-tag>
              <el-tag type="danger" v-else-if="scope.row.isQualified===0">未合格</el-tag>
            </template>
          </el-table-column>
          <el-table-column   label="合格百分比" align="center">
            <template slot-scope="scope">
                <span>{{scope.row.qualifiedPass}} %</span>
            </template>
          </el-table-column>
          <el-table-column   label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="detailShow(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog-zdy>



    <detail ref="detail"></detail>

  </div>





</template>


<script>
import Detail from "./detail";
import  API  from '@/api/yjt/api_class_test.js'
export  default {
  components:{Detail},
  data(){
    return{
      dialogVisible:false,
      bodyHeight: 0,
      dataList:[],
      title:"考试记录"
    }
  },
  mounted() {
    this.bodyHeight = document.body.offsetHeight - 50;
  },
  methods:{
    show(data,dataName){
      this.title=dataName+"-考试记录"
      this.dialogVisible=true;
      API.queryList(data).then(res =>{
        console.log(res)
        if(res.code ===0){
          this.dataList=res.data
        }
      })

    },
    detailShow(row){
      console.log(row)
    let  json=  JSON.parse(row.questionsLibraryJson);
      // console.log(json)
      this.$refs.detail.show(json)
    },

  }
}
</script>


<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/classTestRecord/record.vue